import { useDocumentTitle } from '@mantine/hooks';

import Title from '@/components/content/title/Title';
import OpsLink from '../../opslink/OpsLink';
import { MercuryCol, MercuryGrid } from '@/components/grid/Grid';

interface IssueTitleProps {
  title?: string;
  issueID?: string | number;
  docTitle?: string;
}

const IssueTitle = ({ title, issueID, docTitle }: IssueTitleProps) => {
  const issueTitle = issueID ? `${issueID} | ${title}` : title;
  useDocumentTitle(docTitle ? `${docTitle} | ${issueTitle}` : issueTitle || '');

  return (
    <MercuryGrid>
      <MercuryCol transparent maw={{ md: '70%' }}>
        <Title order={1} size="h2" id="issue__title">
          <span>{issueTitle}</span>
          {issueID && <OpsLink id={issueID} template="issue" />}
        </Title>
      </MercuryCol>
    </MercuryGrid>
  );
};
export default IssueTitle;
